<button [disabled]="isLoading" (click)="onBackButton()" mat-button class="mt-3 ms-3">
    <mat-icon>arrow_back</mat-icon>
    Back
</button>

<div class="container h-75 d-flex align-items-center justify-content-center">
    <div class="row mt-5 d-flex align-items-center justify-content-center">
        <h1 class="text-center">You must validate your account through email</h1>
        <button [disabled]="isLoading" (click)="onSendValidationLinkService()" mat-raised-button class="w-50">
            <span *ngIf="!isLoading">Receive new validation link</span>
            <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>
        </button>
    </div>
</div>